exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-erase-button[data-v-babd898a] {\n    display: inline-block;\n    font-size: 14px;\n    color: rgb(204, 0, 0);\n    cursor: pointer;\n    margin-bottom: 30px;\n}\n.search-show-button[data-v-babd898a] {\n    display: inline-block;\n    background: #F5D76E;\n    padding: 10px 20px;\n    font-size: 20px;\n    font-weight: 700;\n    cursor: pointer;\n    border-radius: 4px;\n    margin: 0 auto 15px;\n}\n#search-show.busy[data-v-babd898a] {\n    background: #ddd;\n    color: #999;\n    cursor: default;\n}\n", ""]);

// exports
